// import { createSelector } from 'reselect'

export const getUsers = state => state.users
export const getModels = state => state.models
export const getGroups = state => state.groups
export const getModules = state => state.modules
export const getGroupModels = state => state.groupModels